export const HIDE_FILTER_DOMAINS = ['galgotias.univiser.io'];
